import { useDispatch, useSelector } from "react-redux";
import {
  ApiCallState,
  isApiCallCompletedSuccessfully,
  isApiCalled,
  isApiCallFailed,
  isApiCallLoading,
} from "src/common/ApiCall";
import { InformationAssetsAccessesActions } from "../../models/information-asset-accesses";
import { RootState } from "./../../../../redux/store";

export function useFetchInformationAssetsAccessesApiCallState(): ApiCallState {
  const { progress, error } = useSelector(
    (rootState: RootState) => rootState.informationAssetsAccesses.informationAssetsAccessesPEV
  );

  const dispatch = useDispatch();

  function dispatchApiCall(resetApiCall :Boolean) {
    if (!isApiCalled(progress) || resetApiCall) {
      dispatch(InformationAssetsAccessesActions.fetchInformationAssetsAccesses());
    }
  }

  return new ApiCallState(
    isApiCalled(progress),
    isApiCallFailed(error),
    isApiCallLoading(progress),
    isApiCallCompletedSuccessfully(progress, error),
    dispatchApiCall
  );
}
